import { SESSION_CONFIG } from '../config/sessionConfig';

class SessionTimeoutService {
  constructor() {
    this.timeoutId = null;
    this.warningId = null;
    this.onTimeout = null;
    this.onWarning = null;
    this.lastActivity = Date.now();
    this.isActive = false;
  }

  setTimeoutCallbacks(onTimeout, onWarning) {
    this.onTimeout = onTimeout;
    this.onWarning = onWarning;
  }

  start() {
    // stop any old timers
    this.clearTimers();
    if (this.isActive) return;
    this.isActive = true;
    this.reset();
    this.addActivityListeners();
    this.lastActivity = Date.now(); // ✅ always fresh when starting
  }

  stop() {
    this.isActive = false;
    this.clearTimers();
    this.removeActivityListeners();
  }

  reset() {
    if (!this.isActive) return;

    this.clearTimers(); // important

    const timeSinceLastActivity = Date.now() - this.lastActivity;
    const timeLeft = SESSION_CONFIG.TIMEOUT_DURATION - timeSinceLastActivity;

    // warning timer
    this.warningTimer = setTimeout(() => {
      console.log('⚠️ Show warning popup');
      if (this.onWarning) this.onWarning();
    }, timeLeft - SESSION_CONFIG.WARNING_DURATION);

    // timeout timer
    this.timeoutTimer = setTimeout(() => {
      console.log('⏳ Session expired');
      if (this.onTimeout) this.onTimeout();
      this.stop();
    }, timeLeft);
    // if (!this.isActive) return;

    // this.clearTimers();
    // this.lastActivity = Date.now(); // ✅ set fresh

    // // Set warning timer (30 seconds before timeout)
    // this.warningId = setTimeout(() => {
    //   if (this.onWarning) this.onWarning();
    // }, SESSION_CONFIG.TIMEOUT_DURATION - SESSION_CONFIG.WARNING_DURATION);

    // // Set timeout timer (1 minute total)
    // this.timeoutId = setTimeout(() => {
    //   if (this.onTimeout) this.onTimeout();
    // }, SESSION_CONFIG.TIMEOUT_DURATION);
  }

  clearTimers() {
    clearTimeout(this.warningTimer);
    clearTimeout(this.timeoutTimer);
    this.warningTimer = null;
    this.timeoutTimer = null;
    // if (this.timeoutId) {
    //   clearTimeout(this.timeoutId);
    //   this.timeoutId = null;
    // }
    // if (this.warningId) {
    //   clearTimeout(this.warningId);
    //   this.warningId = null;
    // }
  }

  addActivityListeners() {
    SESSION_CONFIG.ACTIVITY_EVENTS.forEach(event => {
      document.addEventListener(event, this.handleActivity.bind(this), true);
    });
  }

  removeActivityListeners() {
    SESSION_CONFIG.ACTIVITY_EVENTS.forEach(event => {
      document.removeEventListener(event, this.handleActivity.bind(this), true);
    });
  }

  handleActivity = () => {
    this.lastActivity = Date.now();
    this.reset();
  }

  getRemainingTime() {
    const elapsed = Date.now() - this.lastActivity;
    return Math.max(0, SESSION_CONFIG.TIMEOUT_DURATION - elapsed);
  }

  isSessionValid() {
    return this.getRemainingTime() > 0;
  }
}

export default new SessionTimeoutService();
